import React, { Component } from 'react'
import Styled from 'styled-components'
import { transparentize, darken } from 'polished'

import Link from 'components/Link'
import Icon from 'components/Icon'
import Card from 'components/Card'
import ProjectPreview from 'components/ProjectPreview'

const Container = Styled.div`
  position: relative;
  height: 0;
  padding-bottom: calc(100% / (4 / 3));
`

const CardExtended = Styled(Card)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  &:hover, &:focus {
    [data-controls] {
      opacity: 1;
    }
  }
`

const Cover = Styled.div`
  position: relative;
  height: calc(100% - 5rem);
`

const Canvas = Styled.div`
  position: relative;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-bottom: 1px solid ${props => props.theme.colors.gray.shade50};
`

const ViewportContainer = Styled.div`
  margin-top: 2.5rem;
  max-width: calc(100% - 6rem);
  box-shadow: 0 0.25rem 1rem 0 rgba(51, 51, 51, 0.1);
`

const Controls = Styled.div.attrs(() => ({
  'data-controls': 1
}))`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => transparentize(0.1, props.theme.colors.primary.shade400)};
  opacity: 0;
  transition: 300ms;
`

const Control = Styled(Link)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-family: ${props => props.theme.fonts.regular};
  font-size: 0.85rem;
  font-weight: 600;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: ${props => props.theme.colors.white};
  margin: 0.5rem;
  border-radius: ${props => props.theme.radius};
  padding: 0.75rem 1.5rem;
  background-color: ${props => transparentize(0.1, darken(0.2, props.theme.colors.primary.shade400))};
  transition: 300ms;
  cursor: pointer;

  i {
    font-size: 1.125rem;
    letter-spacing: 0;
    line-height: 1;
    margin-left: 0.5rem;
    color: ${props => transparentize(0.1, props.theme.colors.white)};
  }

  &:hover {
    color: ${props => props.theme.colors.white};
    background-color: ${props => transparentize(0.1, darken(0.3, props.theme.colors.primary.shade400))};
  }
`

const Details = Styled(Link)`
  display: block;
  height: 5rem;
  padding: 1rem 1.5rem;
  text-align: center;
`

const Name = Styled.div`
  font-family: ${props => props.theme.fonts.regular};
  font-size: 1.125rem;
  line-height: 1.5rem;
  font-weight: 600;
  color: ${props => props.theme.colors.gray.shade700}
`

const Url = Styled.div`
  font-family: ${props => props.theme.fonts.regular};
  font-size: 0.85rem;
  line-height: 1.5rem;
  color: ${props => props.theme.colors.gray.shade200}
`

export default class extends Component {
  render() {
    return (
      <Container>
        <CardExtended>
          <Cover>
            <Canvas>
              <ViewportContainer>
                <ProjectPreview project={this.props.project} />
              </ViewportContainer>
            </Canvas>

            <Controls>
              <Control href={`https://${this.props.project.url}.flowpage.io`} target="_blank">
                Visit
                <Icon liga="open_in_new" />
              </Control>

              <Control to={`/projects/${this.props.project._id}`}>
                Edit
                <Icon liga="edit" />
              </Control>
            </Controls>
          </Cover>
          <Details to={`/projects/${this.props.project._id}`}>
            <Name>{this.props.project.name}</Name>
            <Url>{this.props.project.url}.flowpage.io</Url>
          </Details>
        </CardExtended>
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ProjectCard/index.js